import { ApiFehler, serverJetzt } from "./client";
import type { Ich } from "./typen";

/** W20b (Server 9bbaf9c): Ein Konto ohne Passwort bestaetigt Passwort festlegen, Konto loeschen,
 *  Haushalt uebergeben und Signieren mit einer frischen Anmeldung per Link. Sie gilt zehn Minuten
 *  (`Ich.nachweis_frisch_bis`); sonst antwortet der Server mit 403 und diesem Text. */
export const FRISCHER_LINK = "Bitte melde dich zuerst mit einem frischen Link an.";

/** Das Konto hat kein Passwort (W20). Ein Server vor W20 schickt das Feld nicht: dann gilt „hat eins“. */
export function ohnePasswort(ich: Ich | null | undefined): boolean {
  return ich?.hat_passwort === false;
}

/** Die Sitzung begann vor hoechstens zehn Minuten per Link (Zeitpunkt aus dem Server, in der Zukunft); W68 (F68-7 A):
 *  ebenso mit Apple oder Google, das Feld setzt der Server dann genauso (`FRISCHE_WEGE`), hier kein eigener Weg.
 *  W20g: verglichen wird mit der Serverzeit, nicht mit der Geraeteuhr (geht sie vor, hing man sonst in
 *  einer Link-Schleife). Ohne Serverzeit gilt, was der Server zuletzt sagte (abgelaufen schickt er null);
 *  laeuft der Nachweis inzwischen ab, antwortet er mit 403 und die App zeigt den Link. */
export function nachweisFrisch(ich: Ich | null | undefined, jetzt: number | undefined = serverJetzt()): boolean {
  const bis = ich?.nachweis_frisch_bis;
  return typeof bis === "string" && (jetzt === undefined || Date.parse(bis) > jetzt);
}

/** Der Server verlangt eine frische Anmeldung per Link (abgelaufen, waehrend das Blatt offen war). */
export function frischerLinkVerlangt(fehler: unknown): boolean {
  return fehler instanceof ApiFehler && fehler.status === 403 && fehler.message === FRISCHER_LINK;
}

/** Ohne Passwort und ohne frischen Nachweis: statt eines Passwortfelds den Link anbieten. */
export function linkStattPasswort(ich: Ich | null | undefined, fehler: unknown): boolean {
  return ohnePasswort(ich) && (!nachweisFrisch(ich) || frischerLinkVerlangt(fehler));
}

// Der Link aus der Mail oeffnet meist einen neuen Tab, und der Server haengt kein Ziel an: Router-
// Zustand und Adresse tragen den Rueckweg also nicht. Gemerkt wird nur der Pfad, so lange der Link gilt.
const ZURUECK = "papiergaist.zurueck";
const LINK_GILT_MS = 15 * 60_000;

/** Nur Pfade dieser App (kein Schema, kein fremder Host, keine Anmeldeseiten). */
function innerhalb(pfad: unknown): pfad is string {
  return typeof pfad === "string" && /^\/(?![/\\])/.test(pfad) && !pfad.startsWith("/anmelden");
}

/** Vor „Link schicken“: hierher kehrt das Einloesen zurueck. */
export function zurueckMerken(pfad: string, jetzt: number = Date.now()): void {
  if (!innerhalb(pfad)) return;
  try {
    localStorage.setItem(ZURUECK, JSON.stringify({ pfad, bis: jetzt + LINK_GILT_MS }));
  } catch {
    // ohne Speicher (privater Modus): dann zum Posteingang
  }
}

/** Beim Abmelden (W20g): sonst landete die naechste Anmeldung per Link im selben Browser auf diesem Pfad. */
export function zurueckVergessen(): void {
  try {
    localStorage.removeItem(ZURUECK);
  } catch {
    // ohne Speicher ist auch nichts gemerkt
  }
}

/** Nach dem Einloesen: der gemerkte Pfad (einmal), sonst der Posteingang. */
export function zurueckHolen(jetzt: number = Date.now()): string {
  try {
    const roh = localStorage.getItem(ZURUECK);
    localStorage.removeItem(ZURUECK);
    const wert = roh ? (JSON.parse(roh) as { pfad?: unknown; bis?: unknown }) : null;
    if (wert && innerhalb(wert.pfad) && typeof wert.bis === "number" && wert.bis > jetzt) return wert.pfad;
  } catch {
    // kaputter Eintrag: Posteingang
  }
  return "/";
}
